module.exports = __webpack_public_path__ + "img/scene1.91be0bd1.webp";